import { AfterContentChecked, AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { MapComponent } from '../map/map.component';
import { MapComponentService } from '../map/map.component.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { MAP_CONSTANTS } from '../../../analytics/constants/analytics.constants';
import * as _ from 'underscore';
import * as M from 'mapbox-gl';
import * as jQuery from 'jquery';
import { AnalyticsDataChachingService } from '../../../analytics/services/analytics.datacaching.service';

@Component({
	selector: 'app-map-v7',
	templateUrl: './map-v7.component.html',
	styleUrls: ['./map-v7.component.css'],
	providers: [MapComponentService]
})
export class MapV7Component extends MapComponent implements OnInit, WidgetCore, AfterViewInit, AfterContentChecked {
	@Input() sectiontitle: any;
	@Input() sectionclass: any;
	@Input() mapboxstyles: any;
	@Input() uniqueoverwriteid: string;
	public popup: any;
	protected miniMapStyle = 'mapbox://styles/freq-e-deek/cjvfire690va11gnomk6gz75i';
	protected mapStyle = 'mapbox://styles/freq-e-deek/cjvfire690va11gnomk6gz75i';
	protected mapFillColor: any;
	public enableZone: boolean = false;
	public enableZip: boolean = false;
	public colorPalette: ColorPalette;
	public showMinimap = false;
	public histogramData = {};
	public chartOptions = {
		chartType: 'bar',
		graphColor: '#2db2bc',
		margin: [0, 0, 0, 0]
	};
	protected PRODUCTS: any = {
		ALL: 'all',
		DISPLAY: 'display'
	};
	public primaryColor: any;
	public tertiaryColor: any;
	public circleMarkerStyles: any;
	public minimapCircleStyle: any;
	@Input() path: any;
	/**
	 *
	 * @type {{productName: string; productKey: string; isDisabled: boolean; isSelected: boolean}[]}
	 */
	protected DEFAULT_PRODUCTS = [
		{
			productName: 'Display',
			productKey: MAP_CONSTANTS.STATE.DISPLAY,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasDisplay'],
			order: 1
		},
		{
			productName: 'Pre Roll',
			productKey: MAP_CONSTANTS.STATE.PREROLL,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasPreroll'],
			order: 4
		},
		{
			productName: 'SEM',
			productKey: MAP_CONSTANTS.STATE.SEM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasSem'],
			order: 7
		},
		{
			productName: 'CTV/OTT',
			productKey: MAP_CONSTANTS.STATE.CTV,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasCtv'],
			order: 8
		},
		{
			productName: 'Audio',
			productKey: MAP_CONSTANTS.STATE.RADIO,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasRadio'],
			order: 9
		}
	];
	protected GF_PRODUCTS = [
		{
			productName: 'Geofence',
			productKey: MAP_CONSTANTS.STATE.GEOFENCE,
			showInLegend: true,
			show: true,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasDisplay'],
			order: 2
		},
		{
			productName: 'Georecency',
			productKey: 'georecency',
			showInLegend: false,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasDisplay'],
			order: 3
		},
		{
			productName: 'Geovideo',
			productKey: MAP_CONSTANTS.STATE.GEOVIDEO,
			showInLegend: true,
			show: true,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasPreroll'],
			productRelated: 'Preroll',
			order: 5
		},
		{
			productName: 'GeorecencyPreroll',
			productKey: 'georecencyPreroll',
			showInLegend: false,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasPreroll'],
			productRelated: 'Preroll',
			order: 6
		}
	];
	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService,
		protected mapComponentService: MapComponentService,
		protected AnalyticsDataChachingService: AnalyticsDataChachingService
	) {
		super(analyticsService, analyticsDataModel, colorUtilityService, mapComponentService, AnalyticsDataChachingService);
	}

	ngOnInit() {
		this.mapCoordinates['lng'] = this.partnerCountryLngLat['lng'] - 23;
		this.mapCoordinates['lat'] = this.partnerCountryLngLat['lat'] + 1;
		super.ngOnInit();
		this.defaultMapZoom = 3.5;
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.histogramData['chartType'] = 'bar';
		this.primaryColor = this.colorUtilityService.getHEXByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'primary',
			1
		);
		this.tertiaryColor = this.colorUtilityService.getHEXByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'tertiary',
			1
		);
		this.circleMarkerStyles = {
			'circle-color': '#fff',
			'circle-radius': 4,
			'circle-stroke-color': this.tertiaryColor,
			'circle-stroke-width': 4
		};
		this.minimapCircleStyle = {
			'circle-color': '#fff',
			'circle-radius': 4,
			'circle-stroke-color': this.primaryColor,
			'circle-stroke-width': 4
		};
		this.mapFillColor = this.colorUtilityService.getRGBByOpacity(this.primaryColor, 0.75);
		this.mapStyle = this.mapboxstyles ? this.mapboxstyles : this.mapStyle;
		this.miniMapStyle = this.mapboxstyles ? this.mapboxstyles : this.miniMapStyle;
	}
	ngAfterViewInit() {
		super.ngAfterViewInit();
	}

	ngAfterContentChecked() {
		jQuery('.geofenceDots').css('border', '4px solid ' + this.primaryColor);
		jQuery('.recencyDots').css('border', '4px solid ' + this.tertiaryColor);
		jQuery('.map-product-item').css('border', '1px solid ' + this.tertiaryColor + ' !important');
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	protected drawGeoFencePoints(product?) {
		if (product) {
			if (product.productKey === MAP_CONSTANTS.STATE.GEOFENCE) {
				this.removeAllGeoFenceMarkers();
				this.geoFenceMarkers = [];
				this.displayGeoFenceData.features.forEach((marker) => {
					// create a DOM element for the marker
					const el = document.createElement('div');
					el.className = 'marker';
					el.style.backgroundImage = 'url(' + this.markericon + ')';
					el.style.backgroundPosition = 'center';
					el.style.backgroundSize = 'cover';
					el.style.width = 22 + 'px';
					el.style.height = 32 + 'px';
					el.addEventListener('mouseover', (event) => {
						this.showGeofenceCenterDetails(marker.properties);
						this.showMinimap = true;
					});

					el.addEventListener('mouseleave', (event) => {
						this.hideGeofenceCenterDetails();
						this.showMinimap = false;
					});

					// add marker to map
					const gfMarker = new M.Marker(el)
						.setLngLat([marker.properties.center_point_longitude, marker.properties.center_point_latitude])
						.addTo(this.map);
					this.geoFenceMarkers.push(gfMarker);
				});
			} else if (product.productKey === MAP_CONSTANTS.STATE.GEOVIDEO) {
				this.removeAllGeoVideoMarkers();
				this.geoVideoMarkers = [];
				this.prerollGeoFenceData.features.forEach((marker) => {
					// create a DOM element for the marker
					const el = document.createElement('div');
					el.className = 'marker';
					el.style.backgroundImage = 'url(' + this.markericon + ')';
					el.style.backgroundPosition = 'center';
					el.style.backgroundSize = 'cover';
					el.style.width = 22 + 'px';
					el.style.height = 32 + 'px';
					el.addEventListener('mouseover', (event) => {
						this.showGeofenceCenterDetails(marker.properties);
						this.showMinimap = true;
					});

					el.addEventListener('mouseleave', (event) => {
						this.hideGeofenceCenterDetails();
						this.showMinimap = false;
					});

					// add marker to map
					const gfMarker = new M.Marker(el)
						.setLngLat([marker.properties.center_point_longitude, marker.properties.center_point_latitude])
						.addTo(this.map);
					this.geoVideoMarkers.push(gfMarker);
				});
			}
		} else {
			this.removeAllGeoFenceMarkers();
			this.geoFenceMarkers = [];
			this.displayGeoFenceData.features.forEach((marker) => {
				// create a DOM element for the marker
				const el = document.createElement('div');
				el.className = 'marker';
				el.style.backgroundImage = 'url(' + this.markericon + ')';
				el.style.backgroundPosition = 'center';
				el.style.backgroundSize = 'cover';
				el.style.width = 22 + 'px';
				el.style.height = 32 + 'px';
				el.addEventListener('mouseover', (event) => {
					this.showGeofenceCenterDetails(marker.properties);
					this.showMinimap = true;
				});

				el.addEventListener('mouseleave', (event) => {
					this.hideGeofenceCenterDetails();
					this.showMinimap = false;
				});

				// add marker to map
				const gfMarker = new M.Marker(el)
					.setLngLat([marker.properties.center_point_longitude, marker.properties.center_point_latitude])
					.addTo(this.map);
				this.geoFenceMarkers.push(gfMarker);
			});
			this.removeAllGeoVideoMarkers();
			this.geoVideoMarkers = [];
			this.prerollGeoFenceData.features.forEach((marker) => {
				// create a DOM element for the marker
				const el = document.createElement('div');
				el.className = 'marker';
				el.style.backgroundImage = 'url(' + this.markericon + ')';
				el.style.backgroundPosition = 'center';
				el.style.backgroundSize = 'cover';
				el.style.width = 22 + 'px';
				el.style.height = 32 + 'px';
				el.addEventListener('mouseover', (event) => {
					this.showGeofenceCenterDetails(marker.properties);
					this.showMinimap = true;
				});

				el.addEventListener('mouseleave', (event) => {
					this.hideGeofenceCenterDetails();
					this.showMinimap = false;
				});

				// add marker to map
				const gfMarker = new M.Marker(el)
					.setLngLat([marker.properties.center_point_longitude, marker.properties.center_point_latitude])
					.addTo(this.map);
				this.geoVideoMarkers.push(gfMarker);
			});
		}
	}
	protected showGeofenceCenterDetails(geofenceCenterPoint) {
		clearTimeout(this.detailsTimeInterval);
		this.showPolygonLayerDetailsFlag = false;
		this.showGeofenceCenterDetailsFlag = true;

		if (geofenceCenterPoint.is_simplifi_restricted_geopoint) {
			jQuery('.geofence-disclaimer').css('display', 'block');
		}
		jQuery('.map-details-container').css({ display: 'block', backgroundColor: 'none' });
		this.geofenceCenterDetails = geofenceCenterPoint;
		this.geofenceCenterDetails.total_android = Math.round(
			(geofenceCenterPoint.android_impression_sum / geofenceCenterPoint.total_impression_sum) * 100
		);
		this.geofenceCenterDetails.total_ios = Math.round(
			(geofenceCenterPoint.ios_impression_sum / geofenceCenterPoint.total_impression_sum) * 100
		);
		let isRetargetingPoint = false;
		for (const geofenceFeatureObj of this.displayGeoFenceData.features) {
			if (geofenceFeatureObj.properties.region_id === geofenceCenterPoint.region_id) {
				isRetargetingPoint = geofenceFeatureObj.properties.is_rtg_center == 1;
				this.detailMapPoints = geofenceFeatureObj;
				break;
			}
		}
		for (const geofenceFeatureObj of this.prerollGeoFenceData.features) {
			if (geofenceFeatureObj.properties.region_id === geofenceCenterPoint.region_id) {
				isRetargetingPoint = geofenceFeatureObj.properties.is_rtg_center == 1;
				this.detailMapPoints = geofenceFeatureObj;
				break;
			}
		}

		if (this.minimap) {
			if (this.minimap.getSource('minimap-data')) {
				if (
					Object.keys(this.detailMapPoints.geometry).length === 0 &&
					this.detailMapPoints.geometry.constructor === Object
				) {
					this.detailMapPoints.geometry = {
						type: 'MultiPoint',
						coordinates: []
					};
				}
				this.minimap.getSource('minimap-data').setData(this.detailMapPoints);
			} else {
				this.minimap.addSource('minimap-data', {
					type: 'geojson',
					data: this.detailMapPoints
				});
				this.minimap.addLayer({
					id: 'minimap-points',
					type: 'circle',
					source: 'minimap-data',
					paint: this.minimapCircleStyle
				});
			}
			if (isRetargetingPoint && this.minimap.getLayer('minimap-points')) {
				this.minimap.setLayoutProperty('minimap-points', 'visibility', 'none');
			} else {
				this.minimap.setLayoutProperty('minimap-points', 'visibility', 'visible');
			}
			this.setMapBounds(this.minimap, this.detailMapPoints, false);
		}
	}

	updateLegendsOrder(legends) {
		return _.sortBy(legends, 'order');
	}

	protected drawRegionsLayer(
		mapSourceLayer: string,
		vectorMapId: string,
		filter: any,
		propertyToFilter: any,
		opacity?: any
	) {
		if (mapSourceLayer === 'polygons') {
			this.removeMapLayer(this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer,
				type: 'fill',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: {
					'fill-color': this.mapFillColor,
					'fill-outline-color': this.mapFillOutlineColor,
					'fill-opacity': opacity
				},
				filter: filter[filter.length - 1]
			});

			this.removeMapLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer,
				type: 'fill',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: {
					'fill-color': this.mapFillColor,
					'fill-outline-color': this.mapFillOutlineColor,
					'fill-opacity': 1
				},
				filter: ['==', propertyToFilter, '']
			});

			let geo_hover_timeout;
			this.map.on('mousemove', this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const gcdId =
						e && e.features && e.features[0].properties['gcd_id'] ? e.features[0].properties['gcd_id'].toString() : '';
					let regionObject = gcdId ? _.findWhere(this.selectedCombination.regionData, { gcd_id: gcdId }) : {};
					this.displayLocationDataOnMouseover(regionObject, e);
				}
				clearTimeout(geo_hover_timeout);
				geo_hover_timeout = setTimeout(() => {
					if (this.map.getLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer)) {
						this.map.setFilter(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer, [
							'==',
							propertyToFilter,
							e && e.feature && e.feature[0] && e.features[0].properties
								? e.features[0].properties[propertyToFilter]
								: ''
						]);
					}
				}, 10);
			});

			this.map.on('mouseleave', this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer, () => {
				this.hideLocationDataOnMouseout();
				clearTimeout(geo_hover_timeout);
				geo_hover_timeout = setTimeout(() => {
					if (this.map.getLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer)) {
						this.map.setFilter(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer, [
							'==',
							propertyToFilter,
							''
						]);
					}
				}, 10);
			});
		} else if (mapSourceLayer === 'points') {
			this.removeMapLayer(this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer,
				type: 'circle',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: {
					'circle-color': '#fff',
					'circle-radius': 0,
					'circle-stroke-color': this.mapFillColor,
					'circle-stroke-width': 0
				},
				filter: filter[filter.length - 1]
			});
			this.map.setLayerZoomRange(this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, 1, 15);

			this.removeMapLayer(this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer,
				type: 'circle',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: {
					'circle-color': '#fff',
					'circle-radius': 4,
					'circle-stroke-color': this.mapFillColor,
					'circle-stroke-width': 1
				},
				filter: ['==', propertyToFilter, '']
			});
			this.map.setLayerZoomRange(this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer, 1, 15);

			this.map.on('mousemove', this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const regionObject = _.findWhere(this.selectedCombination.regionData, {
						gcd_id: e.features[0].properties['gcd_id'].toString()
					});
					this.displayLocationDataOnMouseover(regionObject, e);
				}
			});
			this.map.on('mousemove', this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const regionObject = _.findWhere(this.selectedCombination.regionData, {
						gcd_id: e.features[0].properties['gcd_id'].toString()
					});
					this.displayLocationDataOnMouseover(regionObject, e);
				}
			});
			this.map.on('mouseleave', this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				this.hideLocationDataOnMouseout();
			});
		}
	}

	//Overriding the method to update the condition, which sets this.showGeofenceLegends variable.
	checkIfOnlyGeoFenceProductsSelected(selectedProducts) {
		const selectedLegendItems = _.where(this.legendItems, { isSelected: true });
		const productNames = _.pluck(selectedLegendItems, 'productKey');
		this.showGeofenceLegends = productNames.includes(MAP_CONSTANTS.STATE.GEOFENCE);
	}
}
